/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, CircularProgress, Container, Grid, MenuItem, TextField, Typography, RadioGroup, FormControl, FormControlLabel, Radio, Card } from '@mui/material';
import { Button } from '@lexcelon/react-util';

// Date/Time UI
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';

// Redux
import { connect } from 'react-redux';

// Alerts
import { setError } from '../../alerts';

// Components
import { SSSMapWidget, LineItem } from '../../components';

// API
import { listBoats, listSatelliteMessages } from '../../api';

// Constants
import { DATE_TIME_ZONE_FORMAT, USER_TYPES } from '../../constants';
const BOAT_COLORS = [
  '#FF1493', // deep pink
  '#8A2BE2', // purple
  '#A52A2A', // brown
  '#FF7F50', // coral
  '#FFFF00', // yellow
  '#FF0000', // red
  '#DAA520', // golden rod
  '#7CFC00', // lawn green
  '#4B0082', // indigo
  '#FFE4B5', // tan
];
const RECENT = 'Most recent';
const RANGE = 'Time range';

class Satellite extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boatID: '',
      boats: [],
      satelliteMessages: [],
      isLoadingBoats: false,
      isLoadingSatelliteMessages: false,
      satelliteMessageID: null,

      selectedBoatsMap: new Map(),
      duration: RECENT,
      startTimestamp: null,
      stopTimestamp: null,
    };
  }

  componentDidMount() {
    this.loadBoats();
  }

  loadBoats() {
    this.setState({ isLoadingBoats: true });
    listBoats().then(boats => {
      boats.forEach((boat, index) => {
        boat.setDisplayColor(BOAT_COLORS[index % BOAT_COLORS.length]);
        this.state.selectedBoatsMap.set(boat?.getID(), true);
      });
      this.setState({ boats, boatID: boats?.length > 0 ? boats[0]?.getID() : null, isLoadingBoats: false, selectedBoatsMap: this.state.selectedBoatsMap }, () => {
        if (this.state.boats?.length > 0) {
          this.loadSatelliteMessages();
        }
      });
    }).catch(error => {
      setError(error ? error : 'Error: Unable to retrieve list of boats.');
      this.setState({ isLoadingBoats: false });
    });
  }

  loadSatelliteMessages = () => {
    this.setState({ isLoadingSatelliteMessages: true });
    const selectedBoatIds = Array.from(this.state.selectedBoatsMap.entries())
      .filter(([_, isSelected]) => isSelected)
      .map(([boatId, _]) => boatId);

    listSatelliteMessages({
      boatIds: selectedBoatIds,
      startTimestamp: this.state.startTimestamp?.toMillis(),
      stopTimestamp: this.state.stopTimestamp?.toMillis()
    }).then(satelliteMessages => {
      this.setState({
        satelliteMessages: satelliteMessages,
        isLoadingSatelliteMessages: false,
        satelliteMessageID: satelliteMessages.length > 0 ? satelliteMessages[0].getID() : null
      });
    }).catch(error => {
      setError(error ? error : 'Error: Unable to retrieve list of satellite messages.');
      this.setState({ isLoadingSatelliteMessages: false });
    });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      // Retrieve GPS data and sensor data
      if (event.target.name === 'boatID') {
        this.loadSatelliteMessages();
      }
    });
  }

  onCheckboxChange = (event) => {
    const boatID = parseInt(event.target.name);
    const isChecked = this.state.selectedBoatsMap.get(boatID) == null ? true : event.target.checked;
    this.state.selectedBoatsMap.set(boatID, isChecked);
    this.setState({ selectedBoatsMap: this.state.selectedBoatsMap });
  }

  render() {
    if ((this.state.isLoadingBoats || this.state.isLoadingSatelliteMessages)) {
      return (
        <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 30 }}>
          <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em', marginBottom: '0.5em' }}>Real-Time Data Center</Typography>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <CircularProgress />
          </div>
        </Container>
      );
    }
    if (!(this.state.isLoadingBoats || this.state.isLoadingSatelliteMessages) && this.state.boats?.length == 0) {
      return (
        <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 30 }}>
          <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em', marginBottom: '0.5em' }}>Real-Time Data Center</Typography>
          <div>
            No boats associated with your business.
          </div>
        </Container>
      );
    }

    let selectedSatelliteMessage = this.state.satelliteMessages?.find(message => message.getID() === this.state.satelliteMessageID) ?? null;

    return (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 30 }}>
        <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em', marginBottom: '0.5em' }}>Real-Time Data Center</Typography>

        <Card elevation={3} style={{ backgroundColor: '#DDDDDD', padding: '40px', minWidth: '70%', marginBottom: '2em' }}>
          <Typography variant='h2' style={{ marginBottom: '1em', fontSize: '1.5em', fontWeight: 'bold' }}>Query Real-Time Data</Typography>

          {/* Duration Selection */}
          <FormControl>
            <Typography variant='overline'>Duration</Typography>
            <RadioGroup
              defaultValue={RECENT}
              value={this.state.duration}
              onChange={(event) => this.setState({ duration: event.target.value, startTimestamp: null, stopTimestamp: null })}
              disabled={this.state.isLoadingSatelliteMessages || this.state.isLoadingBoats}
            >
              <FormControlLabel value={RECENT} control={<Radio />} label={RECENT} />
              <FormControlLabel value={RANGE} control={<Radio />} label={RANGE} />
            </RadioGroup>
          </FormControl>

          {/* Date Range Selection */}
          {this.state.duration === RANGE && (
            <>
              <LocalizationProvider dateAdapter={AdapterLuxon}>
                <DateTimePicker
                  renderInput={(props) =>
                    <TextField
                      required
                      variant='filled'
                      style={{ width: '100%', marginBottom: '10px' }}
                      {...props}
                    />
                  }
                  name='startTimestamp'
                  label='Start'
                  value={this.state.startTimestamp}
                  onChange={(newValue) => {
                    this.setState({
                      startTimestamp: newValue,
                      stopTimestamp: this.state.stopTimestamp != null && newValue != null && newValue > this.state.stopTimestamp ? null : this.state.stopTimestamp
                    });
                  }}
                  disabled={this.state.isLoadingSatelliteMessages || this.state.isLoadingBoats}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterLuxon}>
                <DateTimePicker
                  renderInput={(props) =>
                    <TextField
                      required
                      variant='filled'
                      style={{ width: '100%', marginBottom: '10px' }}
                      {...props}
                    />
                  }
                  name='stopTimestamp'
                  label='End'
                  value={this.state.stopTimestamp}
                  onChange={(newValue) => {
                    this.setState({
                      stopTimestamp: newValue,
                      startTimestamp: this.state.startTimestamp != null && newValue != null && newValue < this.state.startTimestamp ? null : this.state.startTimestamp
                    });
                  }}
                  disabled={this.state.isLoadingSatelliteMessages || this.state.isLoadingBoats}
                />
              </LocalizationProvider>
            </>
          )}

          {/* List of Boats */}
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2em' }}>
            <Typography variant='overline'>Vessels</Typography>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              {this.state.boats?.map((boat, index) => (
                <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Checkbox
                    name={boat.getID()?.toString()}
                    checked={this.state.selectedBoatsMap.get(boat.getID()) == null ? true : this.state.selectedBoatsMap.get(boat.getID())}
                    onChange={this.onCheckboxChange}
                    sx={{ color: boat.getDisplayColor(), '&.Mui-checked': { color: boat.getDisplayColor() } }}
                    disabled={this.state.isLoadingSatelliteMessages || this.state.isLoadingBoats}
                  />
                  <Typography variant='body1' style={{ color: boat.getDisplayColor(), fontWeight: 'bold' }}>{boat.getName()}</Typography>
                </div>
              ))}
            </div>
          </div>

          <Button
            style={{ marginTop: '2em' }}
            disabled={this.state.isLoadingBoats || Array.from(this.state.selectedBoatsMap.values()).filter(value => value).length === 0  || (this.state.duration === RANGE && (this.state.startTimestamp == null || this.state.stopTimestamp == null))}
            isLoading={this.state.isLoadingSatelliteMessages}
            onClick={this.loadSatelliteMessages}>Update View</Button>
        </Card>

        {/* No Satellite Messages Message */}
        {!this.state.isLoadingSatelliteMessages && this.state.satelliteMessages?.length === 0 &&
        <Typography variant='body1'>No satellite data meets the selected criteria.</Typography>}

        {/* Map Widget & Locations */}
        {this.state.satelliteMessages?.length > 0 &&
        <SSSMapWidget
          satelliteMessages={this.state.satelliteMessages?.map(satelliteMessage => {
            // Add the satelliteMessage color
            const boatID = satelliteMessage.getCamera()?.getBoatID();
            const displayColor = this.state.boats?.find(boat => boat.getID() === boatID)?.getDisplayColor();

            satelliteMessage.setDisplayColor(displayColor);

            return satelliteMessage;
          })}
          height={350}
          width={'100%'}
          style={{ marginBottom: 20 }}
          onSelect={(satelliteMessageID) => this.setState({ satelliteMessageID })}
          selectedSatelliteMessageID={this.state.satelliteMessageID}
        />}

        {/* All Data */}
        {selectedSatelliteMessage != null &&
        <Grid container direction='row' style={{ justifyContent: 'center' }}>

          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Last Update'
              value={selectedSatelliteMessage.getRecordedTimestamp()?.toLocaleString(DATE_TIME_ZONE_FORMAT)}
              centered
            />
          </Grid>

          {selectedSatelliteMessage?.getCameraInputs()?.map((cameraInput, index) => {
            let description = cameraInput.getCameraKeyType().getDescription();
            let units = cameraInput.getCameraKeyType().getUnits() != null ? ' [' + cameraInput.getCameraKeyType().getUnits() + ']' : '';
            let inputNumber = cameraInput.getInputNumber() != null ? ' [input ' + cameraInput.getInputNumber() + ']' : '';
            return (
              <Grid key={index} item style={{ width: 325 }}>
                <LineItem
                  description={description + (cameraInput.getDisplayValue() === cameraInput.getValue() ? units : '') + inputNumber}
                  value={cameraInput.getDisplayValue()}
                  centered
                  fixed={2}
                />
              </Grid>
            );
          })}
          {selectedSatelliteMessage.getUsbUtilizedPercentage() != null &&
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='USB Utilized Percentage'
              value={selectedSatelliteMessage.getUsbUtilizedPercentage() === -1 ? 'N/A' : `${selectedSatelliteMessage.getUsbUtilizedPercentage()}%`}
              centered
            />
          </Grid>}
          {selectedSatelliteMessage.getShutdownSwitch() != null &&
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Shutdown Switch'
              value={selectedSatelliteMessage.getShutdownSwitch() === 1 ? 'Shutdown' : 'Running'}
              centered
            />
          </Grid>}
          {selectedSatelliteMessage.getFirmwareState() != null &&
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Firmware State'
              value={selectedSatelliteMessage.getFirmwareStateText()}
              centered
            />
          </Grid>}
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Satellite Latitude [Est]'
              value={selectedSatelliteMessage.getLatitude()}
              centered
              fixed={2}
            />
          </Grid>
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Satellite Longitude [Est]'
              value={selectedSatelliteMessage.getLongitude()}
              centered
              fixed={2}
            />
          </Grid>
          {selectedSatelliteMessage.getCep() != null &&
          <Grid item style={{ width: 325 }}>
            <LineItem
              description='Satellite Estimated Accuracy [+/- Km]'
              value={selectedSatelliteMessage.getCep()}
              centered
              fixed={2}
            />
          </Grid>}
        </Grid>}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  userType: state.auth.userType
});

Satellite.propTypes = {
  userType: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(Satellite);
